var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 29 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.808 1.233a3.45 3.45 0 0 0 .44 4.838l17.447 14.54L2.248 35.152a3.435 3.435 0 1 0 4.402 5.271l20.614-17.174a3.433 3.433 0 0 0 0-5.274L6.65.798a3.44 3.44 0 0 0-4.842.435"
  })));
};
export default SvgArrowRight;